import styled from 'styled-components';
import AppCSS from '../../utils/styled';

export const Components = {
  Container: styled.div`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 16px 24px;
    background-color: ${AppCSS.colors.utility.screenBackground};
    gap: 32px;
  `,

  TabContainer: styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 32px;
  `,
};
